/**
 * Axios Configuration - Global Setup
 *
 * This file configures axios interceptors to automatically:
 * 1. Add authentication tokens to all API requests
 * 2. Handle authentication errors globally
 * 3. Redirect to login when unauthorized
 */

import axios from 'axios';

// Request Interceptor - Automatically adds auth token
axios.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('access_token');

    // Add Authorization header if token exists and not already set
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor - Handles auth errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - Token expired or invalid
    if (error.response?.status === 401) {
      // Clear invalid token
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('authToken');

      // Silent redirect — no blocking alert() dialog.
      // Consumers that need a toast can listen for the rejection.
      const path = window.location.pathname;
      const publicPaths = ['/login', '/register', '/Register', '/forgot-password'];
      if (!publicPaths.some(p => path.startsWith(p))) {
        // Preserve where the user was trying to go so login can redirect back.
        const redirect = encodeURIComponent(path + window.location.search);
        window.location.href = `/login?redirect=${redirect}`;
      }
    }

    // 500 errors: reject with the error so the caller can decide how to display it.
    // Never use a blocking alert().
    return Promise.reject(error);
  }
);

export default axios;
